import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[chatbot-web] uncaught render error", error, info);
  }

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="cw-fatal">
        <h1 className="cw-fatal__title">chat indisponible</h1>
        <p className="cw-fatal__lead">
          quelque chose s'est cassé côté frontend. recharge la page (Cmd+Shift+R) ;
          si ça persiste, copie le détail ci-dessous à David.
        </p>
        <pre className="cw-fatal__detail">{error.stack ?? error.message}</pre>
      </div>
    );
  }
}
